import Service from "../../services";

const animalModule = {
  namespaced: true,
  state: {
    list: [],
    filter: [],
    data: {
      id: "",
      an: "",
      ln: "",
      hn: "",
      doctor_name: "",
      hospital_id: "",
      hospital_name: "",
      name: "",
      sex: "",
      age: "",
      breed: 119,
      breed_id: 119,
      species: { id: 2 },
      species_id: 2,
      species_name: "",
      other_specie: "",
      other_breed: "",
      color: "",
      owner_name: "",
      owner_surname: "",
      owner_title_name: null,
      owner_address: "",
      note: "",
      order_date: "",
      gender: {
        id: "",
        gender_name: "",
      },
      created_at: null,
      updated_at: null,
      created_by: null,
      updated_by: null,
    },
    filters: {
      page_no: "1",
      direction: null,
      hospital: null,
      species_id: null,
      gender: null,
      owner_name: null,
      pet_name: null,
      hn: null,
      dateOne: "",
      dateTwo: "",
    },
  },
  mutations: {
    REMOVE_ANIMAL_ID: (state) => {
      state.data.id = "";
      state.data.an = "";
    },
    SET_HOSPITAL_NAME: (state, hospital_name) => {
      state.data.hospital_name = hospital_name;
    },
    SET_FILTER: (state, data) => {
      state.filters = data;
    },
    GET_ALL_PETS: (state, data) => {
      state.list = data;
    },
    FILTER_PETS: (state, data) => {
      state.filter = data;
    },
    SET_DATA: (state, data) => {
      (state.data.id = data.id),
        (state.data.an = data.an),
        (state.data.hn = data.hn),
        (state.data.ln = data.ln),
        (state.data.doctor_name = data.doctor_name),
        (state.data.hospital_id = data.hospital_id ? data.hospital_id : ""),
        (state.data.hospital_name = data.hospital_name),
        (state.data.name = data.name),
        (state.data.sex = data.sex ? data.sex : ""),
        (state.data.age = data.age),
        (state.data.breed = data.breed),
        (state.data.breed_id = data.breed_id),
        (state.data.species_id = data.species_id ? data.species_id : ""),
        (state.data.species_name = data.species_id ? data.species_name : ""),
        (state.data.other_specie = data.other_specie),
        (state.data.other_breed = data.other_breed),
        (state.data.species = data.species ? data.species : ""),
        (state.data.color = data.color),
        (state.data.owner_name = data.owner_name),
        (state.data.owner_surname = data.owner_surname),
        (state.data.owner_title_name = data.owner_title_name),
        (state.data.owner_address = data.owner_address),
        (state.data.note = data.note),
        (state.data.gender = data.gender
          ? data.gender
          : { gerder_name: "", id: "" }),
        (state.data.created_at = data.created_at),
        (state.data.created_by = data.created_by),
        (state.data.updated_at = data.updated_at),
        (state.data.updated_by = data.updated_by);
    },
    SET_AN_DATA: (state, data) => {
      state.data.an = data;
    },
  },
  actions: {
    setFilter(context, filter) {
      context.commit("SET_FILTER", filter);
    },
    getAll: (context) => {
      // Service.animal.getAllPets().then(res => {
      //     context.commit("GET_ALL_PETS", res);
      // })
    },
    async filterData(context, payload) {
      let res = await Service.animal.filterPets(payload);
      context.commit("FILTER_PETS", res);
    },
    setHospitalName: (context, name) => {
      context.commit("SET_HOSPITAL_NAME", name);
    },
    genAN: async (context) => {
      const res = await Service.animal.genAN();
      context.commit("SET_AN_DATA", res);
    },
    setData: (context, id) => {
      if (id) {
        return Service.animal.getPet(id).then((res) => {
          context.commit("SET_DATA", res);
        });
      } else {
        const data = {
          id: "",
          an: "",
          hn: "",
          ln: "",
          doctor_name: "",
          hospital_id: "ชื่อลูกค้า",
          hospital_name: "",
          name: "",
          sex: "",
          age: "",
          breed: 119,
          breed_id: 119,
          species: { id: 2 },
          species_id: 2,
          species_name: "",
          other_specie: "",
          other_breed: "",
          color: "",
          owner_name: "",
          owner_surname: "",
          owner_title_name: null,
          owner_address: null,
          note: "",
          gender: { id: "", gender_name: "" },
          created_at: null,
          updated_at: null,
          created_by: null,
          updated_by: null,
        };
        return Service.animal.genAN().then((res) => {
          data.an = res;
          context.commit("SET_DATA", data);
        });
      }
    },
    updateData: (context, payload) => {
      context.commit("GET_ALL_PETS", []);
      if (payload.id != "") {
        if (payload.species_id == "Species") {
          payload.species_id = "";
        }
        if (payload.hospital_id == "ชื่อลูกค้า") {
          payload.hospital_id = "";
        }
        return Service.animal.updatePet(payload.id, payload).then(
          Service.animal.getAllPets().then((res) => {
            context.commit("GET_ALL_PETS", res);
          })
        );
      } else {
        if (payload.species_id == "Species") {
          payload.species_id = "";
        }
        if (payload.hospital_id == "ชื่อลูกค้า") {
          payload.hospital_id = "";
        }
        return Service.animal.savePet(payload).then(
          Service.animal.getAllPets().then((res) => {
            context.commit("GET_ALL_PETS", res);
          })
        );
      }
    },
    deleteAnimal: async (context, data) => {
      let confirmPassword = await Service.auth.confirmPassword(data.payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.animal.deletePet(data.id, token);
      } else {
        return false;
      }
    },
    getOwnerTitleName: async (context) => {
      return await Service.animal.getOwnerTitleName();
    },
    removeAnimalId: (context) => {
      context.commit("REMOVE_ANIMAL_ID");
    },
  },
  getters: {
    getAll(state) {
      return state.list;
    },
    getData(state) {
      return state.data;
    },
    getDataFromFilter(state) {
      return state.filter;
    },
    getFilter(state) {
      return state.filters;
    },
  },
};

export default animalModule;
